var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.recommendList.length
    ? _c(
        "ul",
        { staticClass: "recommend border-radius-8", style: _vm.myStyle },
        _vm._l(_vm.recommendList, function (item, index) {
          return _c(
            "li",
            {
              key: item.id,
              class: [
                "recommend-item",
                index > _vm.recommendList.length - 5 ? "row-2" : "",
              ],
              style: _vm.itemStyle,
              on: {
                click: function ($event) {
                  return _vm.clickIcon(item.id)
                },
              },
            },
            [
              _c(
                "router-link",
                { staticClass: "item-wrap", attrs: { to: item.href } },
                [
                  _c("lazy-img", {
                    attrs: {
                      width: `${_vm.imgWidth}px`,
                      height: `${_vm.imgWidth}px`,
                      background: "#fff",
                      defaultImgWidth: "28px",
                      src: item.imgUrl,
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }